import { initSentry } from './lib/sentry';
import { reportClientError } from './lib/errorReporter';

// Initialize Sentry BEFORE rendering the app so it catches all errors
initSentry();

import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// --- Stale deployment chunk recovery ---
// After a Vercel deployment, old JS chunk filenames no longer exist.
// Vite fires this event when a preload (dynamic import) fails.
// We auto-reload once so the browser fetches the new index.html with updated chunk refs.
window.addEventListener('vite:preloadError', (event) => {
  const reloadedKey = 'chunk-reload-ts';
  const lastReload = sessionStorage.getItem(reloadedKey);
  const now = Date.now();

  // Prevent infinite reload loops — only reload if we haven't reloaded in the last 10 seconds
  if (!lastReload || now - Number(lastReload) > 10_000) {
    event.preventDefault();
    sessionStorage.setItem(reloadedKey, String(now));
    window.location.reload();
  }
});

window.addEventListener('error', (event) => {
  reportClientError(event.error || event.message, {
    area: 'global',
    action: 'window_error',
    severity: 'error',
    metadata: {
      message: event.message,
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
    },
  });
});

window.addEventListener('unhandledrejection', (event) => {
  reportClientError(event.reason || 'Unhandled promise rejection', {
    area: 'global',
    action: 'unhandled_rejection',
    severity: 'error',
  });
});

createRoot(document.getElementById("root")!).render(<App />);
